import { Card, CardContent } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import S3FilesAndImagesDialog from "@saleor/s3/components";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { SiteLanguageDetailPageFormData } from "../SiteLanguageDetailPage";

export interface CheckoutPopupImagePageProps {
  image: string;
  setImage: any;
  onChange: (event: React.ChangeEvent<any>) => void;
  disabled: boolean;
  data: SiteLanguageDetailPageFormData;
}

const CheckoutPopupImage: React.FC<CheckoutPopupImagePageProps> = ({
  image,
  setImage,
  onChange,
  disabled,
  data
}) => {
  const intl = useIntl();
  const [s3open, setS3Open] = useState(false);
  const [currentS3Media, setcurrentS3Media] = useState("");
  const [currentS3MediaType, setCurrentS3MediaType] = useState("image");

  const loadS3Media = () => {
    const src_url = image;
    if (
      src_url.indexOf(".jpg") > 0 ||
      src_url.indexOf(".png") > 0 ||
      src_url.indexOf(".gif") > 0 ||
      src_url.indexOf(".webp") > 0
    ) {
      setCurrentS3MediaType("image");
    } else if (src_url.indexOf(".mp4") > 0) {
      setCurrentS3MediaType("video");
    }
    setcurrentS3Media(src_url);
    setS3Open(true);
  };
  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Shop Settings"
          })}
        />
        <CardContent>
          <TextField
            style={{ width: "80%" }}
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Checkout Popup Image"
            })}
            name={"checkoutPopupImage" as keyof SiteLanguageDetailPageFormData}
            value={data.checkoutPopupImage}
            onChange={onChange}
          />
          {!disabled && (
            <CloudUploadIcon
              style={{
                marginLeft: 20,
                width: 40,
                height: 40,
                cursor: "pointer"
              }}
              color="primary"
              onClick={loadS3Media}
            />
          )}
          {s3open && (
            <S3FilesAndImagesDialog
              open={s3open}
              onClose={() => {
                setS3Open(false);
              }}
              defaultCurrentS3Media={""}
              setShowS3Media={setS3Open}
              currentS3Media={currentS3Media}
              currentS3MediaType={currentS3MediaType}
              onSelectS3Media={setImage}
            />
          )}
          <FormSpacer />
          {image && (
            <img
              src={image}
              style={{
                width: "400px",
                height: "400px",
                overflow: "hidden",
                objectFit: "cover"
              }}
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};
export default CheckoutPopupImage;
